const RAW_BASE = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001').replace(/\/+$/, '');
export const API_BASE = RAW_BASE.endsWith('/api') ? RAW_BASE : `${RAW_BASE}/api`;

const PLACEHOLDER = 'https://via.placeholder.com/300x400?text=No+Image';

export const getImageUrl = (itemOrPath) => {
  if (!itemOrPath) return PLACEHOLDER;

  let rawImg = null;

  if (typeof itemOrPath === 'object') {
    const sources = [
      itemOrPath.image,
      itemOrPath.imageUrl,
      itemOrPath.images?.[0],
      itemOrPath.url,
      itemOrPath.photo,
      itemOrPath.fileUrl,
    ];
    rawImg = sources.find((s) => typeof s === 'string' && s.trim() !== '') || null;
  } else if (typeof itemOrPath === 'string') {
    rawImg = itemOrPath;
  }

  if (!rawImg || rawImg.trim() === '') return PLACEHOLDER;

  if (rawImg.startsWith('http://') || rawImg.startsWith('https://') || rawImg.startsWith('data:image')) {
    return rawImg;
  }

  const cleanPath = rawImg.startsWith('/') ? rawImg : `/${rawImg}`;
  const encoded = cleanPath.split('/').map(encodeURIComponent).join('/');

  if (cleanPath.startsWith('/uploads/')) {
    return `${API_BASE}${encoded}`;
  }
  return `${API_BASE}/uploads/products${encoded}`;
};

export default getImageUrl;